<div class="modal-header">
  <h4 class="modal-title" *ngIf="title"><fa-icon [icon]="icon"></fa-icon> {{ title }}</h4>
  <button class="close" (click)="close()">&times;</button>
</div>

<div class="modal-body" [innerHTML]="data"></div>
